import { fetchTasksForDescriptor } from './fetchTasksForDescriptor';
import { getTodoCache } from '../todoCache';
import { toTodos } from './toTodos';
import { Todo } from 'owa-todo-types';

const CHUNK_SIZE = 5;

export async function reloadTodos() {
    // Reload todos for all the descriptors
    const allDescriptors = getTodoCache().getDescriptors();
    if (!allDescriptors) {
        return;
    }
    const todos: Todo[] = [];
    let hasLoadingErrors = false;
    for (let i = 0; i < allDescriptors.length; i += CHUNK_SIZE) {
        const chunkPromises = allDescriptors.slice(i, i + CHUNK_SIZE).map(descriptor => {
            return fetchTasksForDescriptor(descriptor).then(response => {
                if (!response || response.errorResponse) {
                    hasLoadingErrors = true;
                } else {
                    todos.push(...toTodos(descriptor, response.Value));
                }
            });
        });
        await Promise.all(chunkPromises);
    }
    if (hasLoadingErrors) {
        // If there are errors during any reload requests, we will add the retrieved items
        // rather than replacing the full cache to avoid populating the cache with incomplete data.
        todos.forEach(todo => getTodoCache().addItem(todo));
    } else {
        getTodoCache().replaceItems(todos);
    }
}
